import { useContext, useMemo } from "react";
import { ConfigurationI18nContext } from "./ConfigurationI18nContext";
import { TranslationNamespace } from "./TranslationNamespace";
import { createNumberFormatter } from "./translators/createNumberFormatter";
import { useCimodeLocaleOverride } from "./useCimodeLocaleOverride";
export function useTranslatorOptions() {
    const i18n = useContext(ConfigurationI18nContext);
    const localeOverride = useCimodeLocaleOverride(i18n);
    const { resolvedLanguage, language, getFixedT, getResourceBundle } = i18n;
    // TODO Better take localeCode from configuration state?
    const localeCode = resolvedLanguage !== null && resolvedLanguage !== void 0 ? resolvedLanguage : language;
    return useMemo(() => {
        const numberFormat = createNumberFormatter(localeCode);
        const translator = getFixedT(localeOverride !== null && localeOverride !== void 0 ? localeOverride : localeCode, TranslationNamespace.Configuration);
        const translations = localeCode
            ? getResourceBundle(localeCode, TranslationNamespace.Configuration)
            : {};
        return {
            translator,
            numberFormat,
            localeCode,
            translations,
        };
    }, [localeOverride, localeCode, getResourceBundle, getFixedT]);
}
//# sourceMappingURL=useTranslatorOptions.js.map